import { atom } from "recoil";
import { OnAgreementRunSubscription } from "../containers/agreements/agreement/types/queries.generated";
import { Maybe } from "../models/generated/graphql";

export const pageSizeOptions = [25, 50, 100, 250];
type ActivePageType = "agreements.activePage" | "publicAgreements.activePage";
type RowsPerPageType = "agreements.rowsPerPage" | "publicAgreements.rowsPerPage";

export interface ActiveTab {
	key: "activeAgreementTab"; // add other modules with multiple table tabs here
	default: number;
}

type ActivePage = {
	key: ActivePageType;
	default: number;
};

type RowsPerPage = {
	key: RowsPerPageType;
	default: number;
};

type AgreementLoadingStatus = {
	key: "isAgreementDetailsLoaded";
	default: boolean;
};

type ActiveDetailsTab = {
	key: "activeDetailsTab";
	default: string;
};

type LastAgreementRunningDate = {
	key: "lastAgreementRunningDate";
	default: Maybe<string>;
};

type ActiveAgreementReport = {
	key: "activeAgreementReport";
	default: Maybe<string>;
};

type AgreementsExecution = {
	key: "agreementsExecution";
	default: Array<OnAgreementRunSubscription["agreementRun"]>;
};

type AgreementsExecutionTotalCount = {
	key: "agreementExecutionTotalCount";
	default: Array<string>;
};

const initialValueAgreementsActivePage: ActivePage = {
	key: "agreements.activePage",
	default: 0,
};

const initialValuePublicAgreementsActivePage: ActivePage = {
	key: "publicAgreements.activePage",
	default: 0,
};

const initialAgreementsRowsPerPage: RowsPerPage = {
	key: "agreements.rowsPerPage",
	default: pageSizeOptions[0],
};

const initialPublicAgreementsRowsPerPage: RowsPerPage = {
	key: "publicAgreements.rowsPerPage",
	default: pageSizeOptions[0],
};

const initialActiveAgreementTabState: ActiveTab = {
	key: "activeAgreementTab",
	default: 0,
};

const agreementDetailsLoadingState: AgreementLoadingStatus = {
	key: "isAgreementDetailsLoaded",
	default: false,
};

const activeTab: ActiveDetailsTab = {
	key: "activeDetailsTab",
	default: "",
};

const lastAgreementRunningDateState: LastAgreementRunningDate = {
	key: "lastAgreementRunningDate",
	default: null,
};

const activeAgreementReportState: ActiveAgreementReport = {
	key: "activeAgreementReport",
	default: null,
};

const agreementsExecutionState: AgreementsExecution = {
	key: "agreementsExecution",
	default: [],
};

const agreementExecutionTotalCountState: AgreementsExecutionTotalCount = {
	key: "agreementExecutionTotalCount",
	default: [],
};

export const agreementsActivePage = atom(initialValueAgreementsActivePage);
export const agreementsRowsPerPage = atom(initialAgreementsRowsPerPage);
export const publicAgreementsActivePage = atom(initialValuePublicAgreementsActivePage);
export const publicAgreementsRowsPerPage = atom(initialPublicAgreementsRowsPerPage);
export const activeAgreementTab = atom(initialActiveAgreementTabState);
export const isAgreementLoaded = atom(agreementDetailsLoadingState);
export const activeDetailsTab = atom(activeTab);
export const lastAgreementRunningDate = atom(lastAgreementRunningDateState);
export const activeAgreementReport = atom(activeAgreementReportState);
export const agreementsExecution = atom(agreementsExecutionState);
export const agreementExecutionTotalCount = atom(agreementExecutionTotalCountState);
